import { render, staticRenderFns } from "./SignatureResource.vue?vue&type=template&id=30813b7c&"
import script from "./SignatureResource.vue?vue&type=script&lang=js&"
export * from "./SignatureResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports